import { z } from "zod/v4";
import { DateTime } from "luxon";
const calendarDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine((value) => DateTime.fromISO(value).isValid, "Date calendaire invalide");
const nullableText = z.string().nullable();
export const VitaleSourceSchema = z.enum(["mock", "real"]);
export const VitaleAddressSchema = z.object({ lines: z.array(z.string()) });
export const VitaleAmoRightSchema = z.object({
    startsOn: calendarDate.nullable(),
    endsOn: calendarDate.nullable(),
});
export const VitaleCoveragePeriodSchema = VitaleAmoRightSchema.extend({
    aldCode: nullableText,
    situationCode: nullableText,
});
export const VitaleCardSchema = z.object({
    serialNumber: z.string(),
    expiresOn: calendarDate.nullable(),
});
export const VitaleInsuredSchema = z.object({
    nir: nullableText,
    nirKey: nullableText,
    regimeCode: nullableText,
    fundCode: nullableText,
    centerCode: nullableText,
    managementCode: nullableText,
});
export const VitaleBeneficiarySchema = z.object({
    id: z.string(),
    usualName: nullableText,
    familyName: z.string(),
    firstName: z.string(),
    birthDate: calendarDate.nullable(),
    birthRank: nullableText,
    quality: nullableText,
    certifiedNir: nullableText,
    certifiedNirKey: nullableText,
    nirCertifiedOn: calendarDate.nullable(),
    address: VitaleAddressSchema,
    amoRights: z.array(VitaleAmoRightSchema),
    coveragePeriods: z.array(VitaleCoveragePeriodSchema),
});
// Mirrors the Companion's camelCase Rust/OpenAPI DTO; no insured-to-beneficiary inference.
export const VitaleReadResultSchema = z.object({
    source: VitaleSourceSchema,
    readAt: z.iso.datetime({ offset: true }),
    consultationDate: calendarDate,
    card: VitaleCardSchema,
    insured: VitaleInsuredSchema,
    beneficiaries: z.array(VitaleBeneficiarySchema),
});
//# sourceMappingURL=VitaleSchemas.js.map